const generateToc = ({ contentSelector, tocContainerSelector, tocListSelector }) => {

  const content = document.querySelector(contentSelector)
  const tocContainer = document.querySelector(tocContainerSelector);
  const tocList = document.querySelector(tocListSelector);

  if (!tocContainer || !tocList || !contentSelector) {
    if (tocContainer) {
      tocContainer.style.display = "none";
      tocContainer.setAttribute("aria-hidden", "true");
    }
    return;
  }

  if (!content) {
    tocContainer.style.display = "none";
    tocContainer.setAttribute("aria-hidden", "true");
    return;
  }

  const headings = [...content.querySelectorAll("h2, h3")].filter(h => /^h[2-3]$/i.test(h.tagName)); 

  if (headings.length === 0) {
    tocContainer.style.display = "none";
    tocContainer.setAttribute("aria-hidden", "true");
    return;
  }

  let currentLevel = 2; 
  const listStack = []; 

  const createList = level => {
    const ol = document.createElement("ol");
    ol.type = level === 2 ? "1" : "a"; 
    return ol;
  };

  const initList = () => {
    const baseList = createList(2);
    tocList.appendChild(baseList);
    listStack.push(baseList);
  };

  initList();


  if (headings[0].tagName.toLowerCase() === "h3") {
    const emptyLi = document.createElement("li");
    emptyLi.innerHTML = "&nbsp"; 
    listStack[0].appendChild(emptyLi);
  }

  headings.forEach(heading => {
    const level = Number(heading.tagName.substring(1)); 

    if (level < 2 || level > 3) return;

    if (level > currentLevel) {
      const newList = createList(level);

      const lastLI = listStack[listStack.length - 1].lastElementChild;
      if (lastLI) {
        lastLI.appendChild(newList);
        listStack.push(newList);
      }
    } else if (level < currentLevel) { 
      while (listStack.length > 1 && currentLevel > level) {
        listStack.pop();
        currentLevel--;
      }
    }

    currentLevel = level;

    const li = document.createElement("li");
    const a = document.createElement("a");

    const id = heading.getAttribute("id");
    a.href = id ? `#${id}` : "#";

    a.textContent = heading.textContent;
    li.appendChild(a);

    listStack[listStack.length - 1].appendChild(li);
  });
};

(function generateTocHandler() {
  window.GlobalSite = window.GlobalSite || {};

  const exportToGlobalSite = GlobalSite.checkDependency('GlobalSite.exportToGlobalSite');

  exportToGlobalSite({
    generateToc,
  });
})();
